document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.custom-product__accordion-item').forEach((item) => {
        const header = item.querySelector('.custom-product__accordion-item-header');
        const content = item.querySelector('.custom-product__accordion-item-content');

        // start collapsed
        content.style.height = '0px';

        header.addEventListener('click', () => {
            const isOpening = !item.classList.contains('is-open');

            // 1) Close any other open items first
            document.querySelectorAll('[data-product-info-accordion].is-open').forEach((other) => {
                if (other !== item) {
                    other.classList.remove('is-open');
                    const otherContent = other.querySelector('.custom-product__accordion-item-content');
                    // freeze at current height then animate to 0
                    const h = otherContent.getBoundingClientRect().height;
                    otherContent.style.height = h + 'px';
                    // force reflow
                    void otherContent.offsetHeight;
                    otherContent.style.height = '0px';
                }
            });

            // 2) Toggle this one
            item.classList.toggle('is-open', isOpening);

            if (isOpening) {
                // OPEN: animate from 0 → full
                const fullH = content.scrollHeight;
                content.style.height = fullH + 'px';
                content.addEventListener('transitionend', function cleanup() {
                    if (item.classList.contains('is-open')) {
                        content.style.height = 'auto';
                    }
                    content.removeEventListener('transitionend', cleanup);
                });
            } else {
                // CLOSE: from auto (or whatever) → 0
                const curH = content.getBoundingClientRect().height;
                content.style.height = curH + 'px';
                void content.offsetHeight;
                content.style.height = '0px';
            }
        });
    });
});
